/** @jsxRuntime classic */
// @ts-check
import { FavoritesProvider } from './useFavorite';
import React from 'react';

export default function wrapRootElement({ element }) {
  return <FavoritesProvider>{element}</FavoritesProvider>;
}
